import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';

import {LayoutViewStore, SingleLayoutViewStore, ColumnLayoutViewStore, ColumnsWithTitleLayoutViewStore, RowsLayoutViewStore, TableLayoutViewStore} from './viewstore';
import {LayoutContentModel} from './contentmodel';




//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class LayoutComponent extends BaseComponent {

    static get ViewStore() {
        return LayoutViewStore;
    }
  
    render() {

        alert("Render should not be called on base LayoutComponent.");
    }
}
export default LayoutComponent; //need to export top level component as "default"


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class SingleLayoutComponent extends LayoutComponent {

    static get ViewStore() {
        return SingleLayoutViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form,
            lastCm,
            viewBreadcrumbs,
            insideEditor
        } = this.props;

        const {
            includeWrapperDivs,
            css,
            child
        } = contentModel; // this contentModel's properties

        var props = {
            currentView: {contentModel: contentModel},
            options: {contentModel: child},
            contentModel: child,
            lastCm: lastCm,
            viewBreadcrumbs: viewBreadcrumbs,
            insideEditor: insideEditor,
            form: form,
        };
        var element = child && child.Component ? React.createElement(child.Component, props) : <div>No Child Provided</div>;

        if(includeWrapperDivs) {
            return (
                <div className={"layout single " + css}>
                    {element}
                </div>
            )
        }
        else {
            return {element};
        }
    }
}

//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class ColumnLayoutComponent extends LayoutComponent {

    static get ViewStore() {
        return ColumnLayoutViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form,
            lastCm,
            viewBreadcrumbs,
            insideEditor
        } = this.props;

        const {
            includeWrapperDivs,
            css,
            children
        } = contentModel; // this contentModel's properties

        var elements = [];
        for(var i = 0; i < children.length; ++i) {
            var props = {
              currentView: {contentModel: contentModel},
              options: {contentModel: children[i]},
              contentModel: children[i],
              lastCm: lastCm,
              viewBreadcrumbs: viewBreadcrumbs,
              insideEditor: insideEditor,
              form: form,
              key: i,
            };
            if(includeWrapperDivs) {
                elements.push(
                    <div className="column" key={"column-" + i}>{React.createElement(children[i].Component, props)}</div>
                );
            }
            else {
                elements.push(React.createElement(children[i].Component, props));
            }
        }

        return (
            <div className={"layout columns " + css}>
                {elements}
            </div>
        )
    }
}
//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class ColumnsWithTitleLayoutComponent extends LayoutComponent {

    static get ViewStore() {
        return ColumnsWithTitleLayoutViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form,
            lastCm,
            viewBreadcrumbs,
            insideEditor
        } = this.props;

        const {
            includeWrapperDivs,
            css,
            title,
            children
        } = contentModel; // this contentModel's properties

        var elements = [];
        for(var i = 0; i < children.length; ++i) {
            var props = {
              currentView: {contentModel: contentModel},
              options: {contentModel: children[i]},
              contentModel: children[i],
              lastCm: lastCm,
              viewBreadcrumbs: viewBreadcrumbs,
              insideEditor: insideEditor,
              form: form,
              key: i,
            };
            if(includeWrapperDivs) {
                elements.push(
                    <div className="column" key={"column-" + i}>{React.createElement(children[i].Component, props)}</div>
                );
            }
            else {
                elements.push(React.createElement(children[i].Component, props));
            }
        }

        return (
            <div className={"layout rows " + css}>
                <div className="row layout-columns-title" dangerouslySetInnerHTML={{__html:title}}></div>
                <div className="row">
                    <div className={"layout columns " + css}>
                        {elements}
                    </div>
                </div>
            </div>
        )
    }
}
//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class RowLayoutComponent extends LayoutComponent {

    static get ViewStore() {
        return RowsLayoutViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form,
            lastCm,
            viewBreadcrumbs,
            insideEditor
        } = this.props;

        const {
            includeWrapperDivs,
            css,
            children
        } = contentModel; // this contentModel's properties

        var elements = [];
        for(var i = 0; i < children.length; ++i) {
            var props = {
              currentView: {contentModel: contentModel},
              options: {contentModel: children[i]},
              contentModel: children[i],
              lastCm: lastCm,
              viewBreadcrumbs: viewBreadcrumbs,
              insideEditor: insideEditor,
              form: form,
              key: i,
            };
            if(includeWrapperDivs) {
                elements.push(
                    <div className="row" key={"row-" + i}>{React.createElement(children[i].Component, props)}</div>
                );
            }
            else {
                elements.push(React.createElement(children[i].Component, props));
            }
        }

        return (
            <div className={"layout rows " + css}>
                {elements}
            </div>
        )
    }
}
//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class TableLayoutComponent extends LayoutComponent {

    static get ViewStore() {
        return TableLayoutViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form,
            lastCm,
            viewBreadcrumbs,
            insideEditor
        } = this.props;

        const {
            css,
            rows,
            columns,
            children
        } = contentModel; // this contentModel's properties

        var elements = [];
        var rowElements = [];
        var currentRow = 0;
        for(var i = 0; i < rows * columns; ++i) {
            var row = Math.floor(i / columns);
            var column = i % columns;

            var cell = null;
            if(i < children.length) {
                var props = {
                  currentView: {contentModel: contentModel},
                  options: {contentModel: children[i]},
                  contentModel: children[i],
                  lastCm: lastCm,
                  viewBreadcrumbs: viewBreadcrumbs,
                  insideEditor: insideEditor,
                  form: form,
                  key: i,
                };
                cell = <div className="cell" key={"cell-" + i}>{React.createElement(children[i].Component, props)}</div>;
            }
            else {
                cell = <div className="cell" key={"cell-" + i}></div>
            }

            if(row != currentRow) {
                elements.push(
                    <div className="row" key={"row-" + currentRow}>{rowElements}</div>
                );
                currentRow = row;
                rowElements = [];
            }

            rowElements.push(cell);
        }
        elements.push(
            <div className="row" key={"row-" + currentRow}>{rowElements}</div>
        );
        currentRow = row;
        rowElements = [];

        return (
            <div className={"layout table " + css}>
                {elements}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app_modules/form-control-activity/layouts/component.js